"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DropMenu = function DropMenu(props) {
  var classes = (0, _classnames["default"])("menu-component", props.className);
  var menuListclasses = (0, _classnames["default"])("menu-list", props.align);
  var options = props.values.map(function (option, index) {
    var text = "";
    var listClasses = (0, _classnames["default"])("list-item", props.align, option.className, {
      "selected": option.selected === true,
      "disabled": option.disabled === true,
      "nonSelectable": option.nonSelectable === true
    });
    if (option.label === undefined || option.label === null) {
      option.label = "";
      text = "";
    } else {
      text = option.label;
    }
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "".concat(props.id, "-").concat(index, "-").concat(option.value),
      "data-value": option.value,
      className: listClasses,
      style: option.style,
      onClick: option.onClick,
      onMouseEnter: option.onMouseEnter ? option.onMouseEnter : null
    }, text);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    id: props.id,
    style: props.style
  }, props.header ? props.header : null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: menuListclasses
  }, options), props.footer ? props.footer : null);
};
DropMenu.propTypes = {
  className: _propTypes["default"].string,
  align: _propTypes["default"].oneOf(["left", "middle", "right"]),
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
    selected: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool,
    className: _propTypes["default"].string,
    value: _propTypes["default"].string,
    style: _propTypes["default"].object,
    onClick: _propTypes["default"].func,
    onMouseEnter: _propTypes["default"].func,
    nonSelectable: _propTypes["default"].bool
  })),
  header: _propTypes["default"].object,
  footer: _propTypes["default"].object
};
DropMenu.defaultProps = {
  style: null,
  className: "",
  align: "left",
  values: [],
  header: null,
  footer: null
};
var _default = exports["default"] = DropMenu;